// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_mw-0";
export var animationContainer = "_mw-1";
export var itemPrice = "_mw-a";
export var itemizedContent = "_mw-9";
export var itemizedHeader = "_mw-7";
export var itemizedRow = "_mw-8";
export var itemizedSection = "_mw-6";
export var modalContent = "_mw-2";
export var orderName = "_mw-3";
export var refundOption = "_mw-4";
export var refundOptionsContainer = "_mw-5";
export var shippingLabel = "_mw-b";
export var totalRow = "_mw-c";